import { GoodLuckNames } from "../../../../../../../enums/settings";
import { getGoodLuckImgSource } from "../../../../../../../helpers/GoodLuckHelper";
import { useGoodLuckTranslations } from "../../../../../../../hooks/useGoodLuckTranslations";
import { GoodLuckGridContainer, GoodLuckImageCard, StyledImage } from "./StyledComponents";

interface PDFGoodLuckImagesGridProps {
    selectedImgName: GoodLuckNames;
    onImgChange: (name: GoodLuckNames) => void;
    disabled: boolean;
}

const PDFGoodLuckImagesGrid = (props: PDFGoodLuckImagesGridProps) => {
    const { getTranslatedGoodLuckImgName } = useGoodLuckTranslations();

    const goodLuckNames = Object.values(GoodLuckNames);

    return (
        <GoodLuckGridContainer>
            {goodLuckNames.map((name) => {
                const imageSource = getGoodLuckImgSource(name);
                const translatedName = getTranslatedGoodLuckImgName(name);
                const isSelected = name === props.selectedImgName;

                return (
                    <GoodLuckImageCard
                        key={name}
                        isSelected={isSelected}
                        onClick={props.disabled ? undefined : () => props.onImgChange(name)}
                        disabled={props.disabled}
                    >
                        <StyledImage
                            src={imageSource}
                            alt={translatedName}
                        />
                    </GoodLuckImageCard>
                );
            })}
        </GoodLuckGridContainer>
    );
};

export default PDFGoodLuckImagesGrid;
